'use client';

import { usePathname } from 'next/navigation';

import { denormalizeFilterName, FEATURED_BRANDS_PATH } from '@libs/algolia';

export const useFeaturedBrand = (): string | null => {
    const pathname = usePathname();
    const isFeaturedBrandPage = pathname?.includes(FEATURED_BRANDS_PATH);

    if (isFeaturedBrandPage) {
        return denormalizeFilterName(pathname?.split('/')[2] ?? '');
    }

    return null;
};
